import React, { useEffect, useState } from 'react';
import { Stack } from 'react-bootstrap';
import { useAssessmentsDataContext } from '../../providers/assessments-data-provider';

const styles = {
  range: {
    margin: '0px',
    height: '24px',
  },
};

function SelfPacedRangeSelection({ question }) {
  const { checkAnswersForPage } = useAssessmentsDataContext();
  const q = question.question;
  const [value, setValue] = useState(50);
  const [min, setMin] = useState(50);
  const [max, setMax] = useState(50);

  const valueChanged = (e) => {
    const event = { ...e };
    q.answer = event.target.value;
    setValue(event.target.value);
  };

  useEffect(() => {
    let minValue = 0;
    let maxValue = 100;

    if (q.question.number_answer_min_value_inclusive) {
      minValue = q.question.number_answer_min_value_inclusive;
    }
    if (q.question.number_answer_max_value_inclusive) {
      maxValue = q.question.number_answer_max_value_inclusive;
    }
    setMin(minValue);
    setMax(maxValue);

    if (q.answer) {
      setValue(q.answer);
    } else {
      q.answer = maxValue / 2;
      setValue(maxValue / 2);
    }
    checkAnswersForPage();
  }, [checkAnswersForPage, q]);

  return (
    <Stack className="w-50 mx-auto pt-4 pb-5">
      <div className="d-flex justify-content-center text-smaller text-bolder pb-2">Drag the slider to respond</div>
      <input
        type="range"
        min={min}
        max={max}
        value={value}
        style={styles.range}
        onChange={(event) => {
          valueChanged(event);
        }}
      />
      <div className="d-flex justify-content-center text-smaller text-bolder pt-2">{value}</div>
    </Stack>
  );
}

export default SelfPacedRangeSelection;
